import { createAsyncThunk } from "@reduxjs/toolkit";
import { productsService } from "service/productsService";
import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";

export const getAllProducts = createAsyncThunk(
  "products/getAllProducts",
  async (pageOptions = {}) => {
    try {
      const response = await productsService.getAllProducts(pageOptions);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
);

export const getAllProductsWithoutPagination = createAsyncThunk(
  "products/getAllProductsWithoutPagination",
  async () => {
    try {
      const response = await productsService.getAllProductsWithoutPagination();
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
);

export const getProductById = createAsyncThunk(
  "products/getProductById",
  async (id) => {
    try {
      const response = await productsService.getProductById(id);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
);

export const createProduct = createAsyncThunk(
  "products/createProduct",
  async (productData, { rejectWithValue }) => {
    try {
      const response = await productsService.createProduct(productData);
      Notify(NOTIFY.type.success, NOTIFY.message.add);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateProduct = createAsyncThunk(
  "products/updateProduct",
  async ({ id, productData }, { rejectWithValue }) => {
    try {
      const response = await productsService.updateProduct(id, productData);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteProduct = createAsyncThunk(
  "products/deleteProduct",
  async (id, { rejectWithValue }) => {
    try {
      await productsService.deleteProduct(id);
      Notify(NOTIFY.type.success, NOTIFY.message.delete);
      return id;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const reorderProducts = createAsyncThunk(
  "products/reorderProducts",
  async (productIds, { rejectWithValue }) => {
    try {
      const response = await productsService.reorderProducts(productIds);
      Notify(NOTIFY.type.success, NOTIFY.message.reorder);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const saveMenuSliderItems = createAsyncThunk(
  "products/saveMenuSliderItems",
  async (body, { dispatch, rejectWithValue }) => {
    try {
      const response = await productsService.saveMenuSliderItems(body.products);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      dispatch(getAllProductsWithoutPagination());
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const reorderMenuSlider = createAsyncThunk(
  "products/reorderMenuSlider",
  async ({ id, newOrder }, { dispatch, rejectWithValue }) => {
    try {
      const response = await productsService.reorderMenuSlider({
        id,
        newOrder,
      });
      dispatch(getAllProductsWithoutPagination());
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateCategoryItems = createAsyncThunk(
  "products/updateCategoryItems",
  async (data, { rejectWithValue }) => {
    try {
      const response = await productsService.updateCategoryItems(data);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateProductActive = createAsyncThunk(
  "products/updateProductActive",
  async ({ id, active }, { rejectWithValue }) => {
    try {
      const response = await productsService.updateProductActive(id, {
        active,
      });
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
